import { createSelector } from '@reduxjs/toolkit';
import { CountriesResI } from '../models/Countries';

export const countriessStoreStateSelector = (state) =>
  state.countries;
export const countriesDataSelector = createSelector(
  countriessStoreStateSelector,
  (storeState): CountriesResI => storeState.countries || [],
);

export const loadingCountriesSelector = createSelector(
  countriessStoreStateSelector,
  (storeState): boolean => storeState.isLoading,
);

export const loadDataErrorCountriesSelector = createSelector(
  countriessStoreStateSelector,
  (storeState): boolean => storeState.error,
);

export const dropdownCountriesSelector = createSelector(
  countriesDataSelector,
  (countries) =>
    countries.map((country) => ({
      value: country,
      label: country,
    })),
);
